// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-rU0bVVxH","topContainer":"dp-FoLrdOK4","title":"dp-1GXnIyNP","listContent":"dp-DyDJZyNE","bottomContent":"dp-kBTMKGgr","registerBtn":"dp-6NmPa1yX"};